import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL;

export const adminAxios = () => {
  const t = localStorage.getItem("lm_admin_token");
  return axios.create({
    baseURL: `${API_BASE}/api/admin`,
    withCredentials: true,
    headers: t ? { Authorization: `Bearer ${t}` } : {},
  });
};

export function formatINR(paise) {
  return `₹${Math.round((paise || 0) / 100).toLocaleString("en-IN")}`;
}

export function relativeTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  const diff = Date.now() - d.getTime();
  const s = Math.floor(diff / 1000);
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const days = Math.floor(h / 24);
  if (days < 30) return `${days}d ago`;
  const mo = Math.floor(days / 30);
  if (mo < 12) return `${mo}mo ago`;
  return `${Math.floor(mo / 12)}y ago`;
}

// Only two plans are selectable now: the one-time free trial and paid Starter.
export const PLAN_OPTIONS = [
  "free",
  "starter_monthly",
];

export const PLAN_BADGE_STYLE = {
  free: "bg-lm-tint text-lm-text2 border-lm-border",
  starter_monthly: "bg-blue-50 text-blue-700 border-blue-200",
  growth_monthly: "bg-indigo-50 text-indigo-700 border-indigo-200",
  agency_monthly: "bg-purple-50 text-purple-700 border-purple-200",
  concierge_monthly: "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200",
  starter_annual: "bg-blue-50 text-blue-700 border-blue-200",
  growth_annual: "bg-indigo-50 text-indigo-700 border-indigo-200",
  agency_annual: "bg-purple-50 text-purple-700 border-purple-200",
  ltd_solo: "bg-emerald-50 text-emerald-700 border-emerald-200",
  ltd_agency: "bg-emerald-50 text-emerald-800 border-emerald-300",
  lifetime: "bg-amber-50 text-amber-800 border-amber-300",
};

export function PlanBadge({ plan }) {
  const cls = PLAN_BADGE_STYLE[plan] || "bg-lm-tint text-lm-text2 border-lm-border";
  return (
    <span className={`inline-block text-[10px] font-mono uppercase tracking-widest px-2 py-0.5 rounded border ${cls}`}>
      {plan || "—"}
    </span>
  );
}
